<template>
  <nav
    class="bottom-tabs tw:grid tw:h-(--app-navigation-height) tw:shadow-(--shadow-floating) tw:grid-cols-5 tw:rounded-(--radius-full)"
    :aria-label="t('nkf.navigation')"
  >
    <RouterLink
      v-for="tab in tabs"
      :key="tab.id"
      :to="tab.path"
      :aria-current="active === tab.id ? 'page' : undefined"
      class="bottom-tab tw:flex tw:relative tw:items-center tw:justify-center tw:flex-col tw:gap-1 tw:no-underline tw:type-navigation tw:pt-1 tw:pb-3 tw:px-0.5 tw:max-[376px]:px-0 tw:rounded-(--radius-card-navigation)"
      :class="{ 'is-active': active === tab.id }"
    >
      <AppIcon size="control" :name="tab.icon" />
      <span>{{ t('nkf.' + tab.id) }}</span>
      <span
        v-if="active === tab.id"
        class="active-dot tw:absolute tw:bottom-2.25 tw:w-1.25 tw:h-1.25 tw:bg-(--orange) tw:rounded-[50%]"
        aria-hidden="true"
      ></span>
    </RouterLink>
  </nav>
</template>

<script setup>
// 1. Import necessary components
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';
import { APP_TAB } from '@/shared/constants/app';
import AppIcon from './AppIcon.vue';
// 2. Use
const { t } = useI18n();
defineProps({ active: { type: String, required: true } });
// 3. Define a reactive variable
const tabs = [
  { id: APP_TAB.HOME, icon: 'home', path: '/home' },
  { id: APP_TAB.FLUID, icon: 'drop', path: '/fluid' },
  { id: APP_TAB.SYMPTOMS, icon: 'pulse', path: '/symptoms' },
  { id: APP_TAB.DIET, icon: 'utensils', path: '/diet' },
  { id: APP_TAB.MORE, icon: 'grid', path: '/more' },
];
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>

<style scoped>
.bottom-tabs {
  background: var(--primary);
}
.bottom-tab {
  color: color-mix(in srgb, var(--primary-foreground) 52.2%, transparent);
  transition:
    color 150ms,
    background 150ms;
}
.bottom-tab > span:not(.active-dot) {
  max-width: 100%;
  white-space: nowrap;
  text-align: center;
}
.bottom-tab.is-active {
  color: var(--primary-foreground);
}
.bottom-tab:active {
  background: color-mix(in srgb, var(--card) 7.1%, transparent);
}
</style>
